import type { ReactiveController, ReactiveControllerHost } from "lit";

import {
  type BookingElementState,
  bookingElementStore,
} from "@/elements/booking-element/booking-element.store";
import {
  lockScroll,
  unlockScroll,
} from "@/elements/scroll-lock/scroll-lock.utilities";
import type { WidgetElementsBookingElementDialogEnterSide } from "@/elements/widget/elements/booking-element/dialog/widget-elements-booking-element-dialog";

export class BookingElementController implements ReactiveController {
  private host: ReactiveControllerHost;

  public activePropertyId: string | undefined;
  public isDialogOpen: boolean;
  public dialogEnterSide:
    | WidgetElementsBookingElementDialogEnterSide
    | undefined;

  public constructor(host: ReactiveControllerHost) {
    host.addController(this);
    this.host = host;
  }

  public openDialog(
    activePropertyId: string | undefined,
    enterSide: WidgetElementsBookingElementDialogEnterSide | undefined,
  ) {
    lockScroll();

    bookingElementStore.setState({
      activePropertyId,
      isDialogOpen: true,
      dialogEnterSide: enterSide,
    });
  }

  public closeDialog() {
    unlockScroll();

    bookingElementStore.setState({ isDialogOpen: false });
  }

  public hostConnected() {
    this.syncState(bookingElementStore.getState());

    this.bookingElementStoreUnsubscribe = bookingElementStore.subscribe(
      (state) => {
        this.syncState(state);

        this.host.requestUpdate();
      },
    );
  }

  public hostDisconnected() {
    unlockScroll();

    this.bookingElementStoreUnsubscribe();
  }

  private bookingElementStoreUnsubscribe: () => void;

  private syncState({
    activePropertyId,
    isDialogOpen,
    dialogEnterSide,
  }: BookingElementState) {
    this.activePropertyId = activePropertyId;
    this.isDialogOpen = isDialogOpen;
    this.dialogEnterSide = dialogEnterSide;
  }
}
